// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1e8db8de","732":"eba6dac9","977":"70f3c322"}[chunkId] + ".chunk.js";
};